export const LOADING_CASUALTY_MONITOR = "LOADING_CASUALTY_MONITOR";
export const SAVE_LOADING_CASUALTY_MONITOR = "SAVE_LOADING_CASUALTY_MONITOR";
export const GET_CASUALTY_MONITOR = "GET_CASUALTY_MONITOR";
export const FORM_FAIL = "FORM_FAIL";
export const CASUALTY_MONITOR_FAIL = "CASUALTY_MONITOR_FAIL";
